export default "__VITE_ASSET__0wRMb6vX__"